// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__YCdc-","content":"LoadingAlert_content__oeGFz"};